module.exports = __webpack_public_path__ + "static/media/leave_club_2.81dd62de.png";